import { render } from "./CountryPlansList.vue?vue&type=template&id=2d5973c0&scoped=true"
import script from "./CountryPlansList.vue?vue&type=script&lang=js"
export * from "./CountryPlansList.vue?vue&type=script&lang=js"

import "./CountryPlansList.vue?vue&type=style&index=0&id=2d5973c0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5973c0"]])

export default __exports__